/**
 * Created by saeed on 12/12/2016.
 */

angular.module('tikonApp').directive('eoDurationValidator', ['AlertService', '$timeout', function (alertService, $timeout) {

    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            $timeout(function () {
                var vm = this;

                //validation message to show
                var message = 'messages.schedule.durationValidator';

                //validator function
                ctrl.$validators.durationValidator = function (modelValue, viewValue) {

                    if (modelValue)
                        if (ctrl.$isEmpty(modelValue)) {
                            // consider empty models to be valid
                            alertService.showValidationMessage(elm, message);
                            return false;
                        }

                    if (modelValue < 15 || modelValue > 10000) {
                        // it is invalid
                        //
                        alertService.showValidationMessage(elm, message);
                        return false;
                    } else {

                        return true;
                    }
                };

            });

        }
    };
}]);
